import { render } from "./MypageFoodListItem.vue?vue&type=template&id=4cd6d8fc&scoped=true&ts=true"
import script from "./MypageFoodListItem.vue?vue&type=script&lang=ts"
export * from "./MypageFoodListItem.vue?vue&type=script&lang=ts"

import "./MypageFoodListItem.vue?vue&type=style&index=0&id=4cd6d8fc&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd6d8fc"]])

export default __exports__